// extracted by mini-css-extract-plugin
export default {"section":"News_section__riGoh","addMore":"News_addMore__bhBU3"};